// extracted by mini-css-extract-plugin
export default {"wrapper":"widget-content_wrapper__AHOW7","grey":"widget-content_grey__g3BbN"};